<div #subtenant *ngIf="formSteps[currentFormIndex] === FormNames.subtenant">
  <app-subtenant-selection  (subtenantClick)="selectedSubtenant($event)"></app-subtenant-selection>
</div>

<div [ngStyle]="{width}" class="single-sign-on" [ngStyle]="displayHideForm(FormNames.userInfo)">
  <app-personal-info #personalInfo [page]="page" [(userProfile)]="userProfile" [showFormNavigationBtn]="false"
    [showUserConsentCheckbox]="false" [hidePhoneNumber]="true">
  </app-personal-info>

  <app-contact-no #contact [page]="page" [(userProfile)]="userProfile" [showFormNavigationBtn]="false">
  </app-contact-no>

  <app-marketing-info [(userProfile)]="userProfile" [elementName]="'email'"></app-marketing-info>

  <div class="terms-notice">
    <input type="checkbox" name="termsAgreement" class="opt-in-checkbox" [(ngModel)]="userProfile.termsAgreement"
      required />
    <div class="terms-agreement-text terms-agreement-text-submit">
      Accept
      <span class="tnc-pp-span tertiary-button" (click)="onTermsClick(termsAndConditions)">
        Terms of Service
      </span>
      and
      <span class="tnc-pp-span tertiary-button" (click)="onTermsClick(privacyPolicy)">
        Privacy Policy.
      </span>*
    </div>
  </div>

  <div class="submitButton">
    <button class="p-button l-form-button l-body-bold" type="submit" [disabled]="!allFieldsValid()"
      (click)="next()">
      {{(formSteps.includes(FormNames.survey))?'Continue':'Submit'}}
    </button>
  </div>
</div>

<!-- can't use ngif because we need to override variable in this component -->
<div [ngStyle]="displayHideForm(FormNames.survey)">
  <app-survey [userProfile]="userProfile" [fireEvent]="true"></app-survey>
</div>
